import React from 'react';
import { TopNavigation } from './TopNavigation';
import { styledComponent } from '@dewise-devex/backstage-plugin-mui-uikit-react';

const Container = styledComponent('div')(({ theme }) => ({
  backgroundColor: theme.palette.surface.dim,
  minHeight: '100vh',
}));

export const Root: React.FC = ({ children }) => {
  return (
    <Container>
      <TopNavigation />
      {children}
    </Container>
  );
};
